import { taskApi } from 'api';
import { ItemForDistribution } from 'components/productsAndSerevices/ProductDocumentsToDistributeDialog';

export const sendBulkDocumentsToApi = async (items: ItemForDistribution[], brId: string) => {
  return await taskApi.distributeDocumentsBulk({
    brUid: brId,
    distributeDocumentsRequestBulk: { documents: items },
  });
};
